<div>
    <mat-paginator #paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 20]" [length]="subject?.length" (page)="changePage($event)"></mat-paginator>
    <table mat-table matSort [dataSource]="problems" class="problem-table">
        <ng-container matColumnDef="problem">
            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
            <td mat-cell *matCellDef="let problem">
                <app-problem-row [record]="problem" [mode]="'full'"></app-problem-row>
            </td>
        </ng-container>
        <tr class="hide-header" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>
